exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".gate {\n  width: 300px;\n  margin: auto;\n  display: block;\n  position: relative;\n  top: 20px;\n  animation-name: gate-slam;\n  animation-duration: 1s; }\n\n.stonearchway {\n  width: 400px;\n  position: absolute;\n  top: 0;\n  left: 50%;\n  transform: translate(-50%, 0);\n  margin: auto;\n  display: block; }\n\n.container {\n  background: #1a1a1a;\n  position: relative;\n  margin: -104px 0 0;\n  height: 100vh; }\n\n@keyframes gate-slam {\n  0% {\n    top: -1000px; }\n  100% {\n    top: 20px; } }\n\n@keyframes text-appear {\n  0% {\n    opacity: 0; }\n  50% {\n    opacity: 0; }\n  100% {\n    opacity: 1; } }\n\n.forbiddenmessage {\n  color: white;\n  font-family: arial;\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  text-align: center;\n  animation-name: text-appear;\n  animation-duration: 2.5s; }\n\nh1,\nh3 {\n  margin: 0; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /opt/app-root/src/src/app/components/admin/components/forbidden/forbidden.component.scss
// module id = ../../../../../src/app/components/admin/components/forbidden/forbidden.component.scss
// module chunks = main